import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable, of } from "rxjs";
import { AuthService } from "../../modules/auth/auth.service";

@Injectable()
export class AuthCookiesResolver implements Resolve<Observable<any>> {
  constructor(private authService: AuthService) {}

  resolve(): Observable<any> {
    return !this.authService.verifySession()
      ? this.authService.signInWithCookies()
      : of(true);
  }
}
